import axios from 'axios';
import {useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import Loading from '../../common/Loading';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function LoadListListItemLoadLockExpire(props) {
    //console.debug("RTS Break LoadListListItemLoadLockExpire");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const[load, setLoad] = useState();
    const[lockExpire, setLockExpire] = useState();


    useEffect(() => {
        setLoad(props.load);
        setLockExpire(props.lockExpire!=null?new Date(props.lockExpire):null);
        setIsLoading(false);
    }, [props]); 


    function setLockExpireVal(e){
        let apiObj = {
            AppUser: user,
            Customer: sessionCustomer.customer,
            Load: load,
            Action: 0,
            LockDate: lockExpire,
            LockExpiration: lockExpire
        }

        let apiURL = apiRoot + "/LoadLocks/SetLoadLockExpire";
        axios
        .post(
            apiURL,
            apiObj, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            props.setLockExpireFx(lockExpire);
            props.setShowLockExpireModalFx(false);            
        })
        .catch(error => {
            console.log("RTS Data Error", error);
        });
    }

    
    if(isLoading){
        return(
            <Loading />
        );
    };


    return (
        <>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box sx={{pt:2}}>
            <DatePicker
                id="tbExpireDate"
                label="Expire Date"
                inputFormat="MM/dd/yyyy"
                value={lockExpire}
                onChange={setLockExpire}
                slotProps={{ field: { clearable: true }, textField:{size:'small'} }}
            />  
        </Box>            
        </LocalizationProvider>
        <Box sx={{textAlign:"right", mt:2}}>
            <Button variant="contained" onClick={setLockExpireVal}>Set</Button>
            <Button variant="contained" sx={{ml:1}} onClick={e => {props.setShowLockExpireModalFx(false);}}>Close</Button>
        </Box>
        </>
    );
}
